import { useRef } from 'react'
import { Button, Card, Row, Col } from 'react-bootstrap'
import {
  buildBatchConfigSnapshot,
  parseBatchConfig,
  todayDateString,
} from '../utils/batchConfig'

const BatchConfigIO = ({
  selectedTasks,
  selectedAccounts,
  taskConfigs,
  requestInterval,
  disabled = false,
  onImport,
  addLog,
}) => {
  const fileInputRef = useRef(null)

  // 导出当前批量任务配置为 JSON 文件
  const handleExport = () => {
    if (!selectedTasks || selectedTasks.length === 0) {
      alert('没有可导出的任务，请先在“任务选择”中勾选任务')
      return
    }

    const snapshot = buildBatchConfigSnapshot({
      tasks: selectedTasks,
      accounts: selectedAccounts || [],
      configs: taskConfigs || {},
      requestInterval,
    })

    try {
      const blob = new Blob([JSON.stringify(snapshot, null, 2)], {
        type: 'application/json',
      })
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = `batch-config-${todayDateString()}.json`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)

      addLog?.(
        `批量任务配置已导出: ${snapshot.tasks.length} 个任务, ${snapshot.accounts.length} 个账号`,
        'success'
      )
    } catch (error) {
      addLog?.(`导出批量任务配置失败: ${error.message}`, 'error')
    }
  }

  // 触发隐藏的文件选择
  const handleImportClick = () => {
    fileInputRef.current?.click()
  }

  // 读取并解析导入的配置文件
  const handleImportChange = (event) => {
    const file = event.target.files?.[0]
    // 先重置，允许重复选择同一文件
    event.target.value = ''
    if (!file) return

    const reader = new FileReader()
    reader.onload = () => {
      const result = parseBatchConfig(String(reader.result || ''))
      if (!result.ok) {
        alert(`导入失败: ${result.error}`)
        addLog?.(`导入批量任务配置失败: ${result.error}`, 'error')
        return
      }
      onImport?.(result.data)
    }
    reader.onerror = () => {
      alert('读取文件失败')
      addLog?.('读取配置文件失败', 'error')
    }
    reader.readAsText(file, 'utf-8')
  }

  return (
    <Card className="mb-3">
      <Card.Header>
        <h6 className="mb-0">配置导入导出</h6>
      </Card.Header>
      <Card.Body>
        <Row className="g-2">
          <Col xs={6}>
            <Button
              variant="outline-primary"
              className="w-100"
              onClick={handleExport}
              disabled={disabled || !selectedTasks?.length}
            >
              📤 导出配置
            </Button>
          </Col>
          <Col xs={6}>
            <Button
              variant="outline-success"
              className="w-100"
              onClick={handleImportClick}
              disabled={disabled}
            >
              📥 导入配置
            </Button>
            <input
              ref={fileInputRef}
              type="file"
              accept=".json,application/json"
              style={{ display: 'none' }}
              onChange={handleImportChange}
            />
          </Col>
        </Row>
        <small className="text-muted d-block mt-2">
          导出当前选中的任务、账号、各任务参数与请求间隔；导入后一键套用。
        </small>
      </Card.Body>
    </Card>
  )
}

export default BatchConfigIO
